<script>
  // make dynamic date to be added to footer
  let date = new Date().getFullYear();
</script>

<footer class="relative  text content-center table1100">
  <div class="flex items-center mt-28">
    <div class="border-t border-4 border-gray-400 flex-grow"></div>
    <div class="px-3 text-gray-800 font-bold text-2xl"><span class="bg-white px-4 text-sm text-gray-500">WEB TASARIM BİRİMİ   © 2024  Bilgi İşlem Daire Başkanlığı
      <a href="https://erdincyasar.uludag.edu.tr">
        <!-- Erdinç Yaşar -->
      </a></span>
    </div>
    <div class="border-t border-4 border-gray-400 flex-grow"></div>
  </div>
  

</footer>
